import { createFileRoute } from '@tanstack/react-router';
import { getClaimOptions } from '../../../../features/claim/claim/queryOptions';
import { DetailsClaimInformation } from '../../../../features/claim/details/detail-claim-information';
import { cardStyles, SectionWithHeader, Typography } from '@maia/ui';
import { twMerge } from 'tailwind-merge';
import parse from 'html-react-parser';

export const Route = createFileRoute(
  '/_authenticated/claims/$guid/_layout/details',
)({
  component: Page,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getClaimOptions(guid)),
});

function Page() {
  const data = Route.useLoaderData();

  // const table = useAttachmentTable(data.attachments ?? []);

  return (
    <div className="content-grid">
      <div className="col-span-full">
        <DetailsClaimInformation claim={data} />
      </div>
      <div className="col-span-full">
        {data.description && (
          <SectionWithHeader title="Omschrijving schade">
            <div
              className={twMerge(cardStyles({ variant: 'outlined' }), 'p-20')}
            >
              <Typography
                variant="body-xs"
                weight="regular"
                className="text-grayscale500"
              >
                {parse(data.description)}
              </Typography>
            </div>
          </SectionWithHeader>
        )}
      </div>
      {/* <Table table={table} className="grid-cols-[auto_min-content]" /> */}
    </div>
  );
}
